var e = {
  alignItems: {
    value: "flex-start"
  },
  alignContent: {
    value: "center"
  },
  flexDirection: {
    value: "column"
  },
  justifyContent: {
    value: "center"
  }
};
export { e as checkboxfield };